<app-table-standard-layout
  [dataSource$]="coupons$"
  [title]="'Coupons / Gavekort'"
  [rowActionButtons]="rowActionButtons"
  [topbarActionButton]="topbarActionButton"
  [columnSettings]="columnSettings">
</app-table-standard-layout>
